import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tugsar-input',
  templateUrl: './tugsar-input.component.html',
  styleUrls: ['./tugsar-input.component.scss']
})
export class TugsarInputComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
